/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Rename_FieldInputs */

const vi_irrigation_rename_field = /** @type {(inputs: Irrigation_Rename_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên hiển thị`)
};

/**

* @param {Irrigation_Rename_FieldInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_rename_field = /** @type {((inputs?: Irrigation_Rename_FieldInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Rename_FieldInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_rename_field(inputs)
});